import React from 'react';
import { MessageSquare, Send, PaperclipIcon, User, Users } from 'lucide-react';
export function Communication() {
  const discussions = [{
    id: 1,
    committee: 'Finance Committee',
    lastMessage: 'Please review the updated budget proposal before our next meeting.',
    unread: 3,
    members: 8
  }, {
    id: 2,
    committee: 'HR Committee',
    lastMessage: 'The new employee handbook draft is ready for review.',
    unread: 0,
    members: 6
  }, {
    id: 3,
    committee: 'IT Committee',
    lastMessage: "Security assessment results will be discussed in tomorrow's meeting.",
    unread: 5,
    members: 5
  }];
  const messages = [{
    id: 1,
    sender: 'Mohammed Al Hashimi',
    time: '10:15 AM',
    content: "Good morning everyone. I've uploaded the latest financial reports to the document library. Please review before our meeting tomorrow.",
    isCurrentUser: false
  }, {
    id: 2,
    sender: 'Aisha Al Mansoori',
    time: '10:22 AM',
    content: "Thanks Mohammed. I'll take a look and prepare my notes.",
    isCurrentUser: false
  }, {
    id: 3,
    sender: 'You',
    time: '10:30 AM',
    content: "I've also added some comments to the Q3 forecast section. Please pay special attention to the projected expenses for the new initiative.",
    isCurrentUser: true
  }, {
    id: 4,
    sender: 'Fatima Al Zaabi',
    time: '10:45 AM',
    content: 'I noticed some discrepancies in the marketing budget allocation. Can we discuss this specifically during the meeting?',
    isCurrentUser: false
  }];
  return <div data-id="element-992">
      <div className="flex justify-between items-center mb-6" data-id="element-993">
        <h1 className="text-2xl font-bold" data-id="element-994">Communication & Suggestions</h1>
        <button className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" data-id="element-995">
          New Suggestion
        </button>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6" data-id="element-996">
        {/* Committees List */}
        <div className="bg-white rounded-lg shadow-sm p-4 lg:col-span-1" data-id="element-997">
          <h2 className="text-lg font-semibold mb-4" data-id="element-998">Committee Discussions</h2>
          <div className="space-y-3" data-id="element-999">
            {discussions.map(discussion => <div key={discussion.id} className={`p-3 rounded-lg cursor-pointer ${discussion.id === 1 ? 'bg-orange-50 border border-orange-200' : 'hover:bg-gray-50'}`} data-id="element-1000">
                <div className="flex justify-between items-start mb-1" data-id="element-1001">
                  <h3 className="font-medium" data-id="element-1002">{discussion.committee}</h3>
                  {discussion.unread > 0 && <span className="bg-orange-500 text-white text-xs rounded-full px-2 py-1" data-id="element-1003">
                      {discussion.unread}
                    </span>}
                </div>
                <p className="text-sm text-gray-500 line-clamp-2 mb-2" data-id="element-1004">
                  {discussion.lastMessage}
                </p>
                <div className="flex items-center text-xs text-gray-400" data-id="element-1005">
                  <Users size={14} className="mr-1" data-id="element-1006" />
                  <span data-id="element-1007">{discussion.members} members</span>
                </div>
              </div>)}
          </div>
        </div>
        {/* Chat Area */}
        <div className="bg-white rounded-lg shadow-sm lg:col-span-3 flex flex-col h-[600px]" data-id="element-1008">
          {/* Chat Header */}
          <div className="p-4 border-b border-gray-200" data-id="element-1009">
            <div className="flex justify-between items-center" data-id="element-1010">
              <div data-id="element-1011">
                <h2 className="font-semibold" data-id="element-1012">Finance Committee</h2>
                <p className="text-sm text-gray-500" data-id="element-1013">8 members</p>
              </div>
              <button className="text-gray-500 hover:text-gray-700" data-id="element-1014">
                <Users size={20} data-id="element-1015" />
              </button>
            </div>
          </div>
          {/* Messages */}
          <div className="flex-1 overflow-y-auto p-4 space-y-4" data-id="element-1016">
            {messages.map(message => <div key={message.id} className={`flex ${message.isCurrentUser ? 'justify-end' : 'justify-start'}`} data-id="element-1017">
                <div className={`max-w-[70%] ${message.isCurrentUser ? 'bg-orange-500 text-white rounded-tl-lg rounded-tr-lg rounded-bl-lg' : 'bg-gray-100 text-gray-800 rounded-tl-lg rounded-tr-lg rounded-br-lg'} p-3`} data-id="element-1018">
                  <div className="flex justify-between items-center mb-1" data-id="element-1019">
                    <span className="font-medium text-sm" data-id="element-1020">
                      {message.isCurrentUser ? 'You' : message.sender}
                    </span>
                    <span className="text-xs opacity-75" data-id="element-1021">{message.time}</span>
                  </div>
                  <p className="text-sm" data-id="element-1022">{message.content}</p>
                </div>
              </div>)}
          </div>
          {/* Message Input */}
          <div className="p-4 border-t border-gray-200" data-id="element-1023">
            <div className="flex items-center" data-id="element-1024">
              <button className="p-2 text-gray-500 hover:text-gray-700" data-id="element-1025">
                <PaperclipIcon size={20} data-id="element-1026" />
              </button>
              <input type="text" placeholder="Type your message here..." className="flex-1 border border-gray-200 rounded-md px-4 py-2 mx-2 focus:outline-none focus:ring-1 focus:ring-orange-500" data-id="element-1027" />
              <button className="p-2 bg-orange-500 text-white rounded-md hover:bg-orange-600" data-id="element-1028">
                <Send size={20} data-id="element-1029" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}